<template>
  <div>
    <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    >
      <question @close="close" :showLoader="showLoader" :directQuestionaire="true" :taskType="taskAnonymous"></question>
    </v-dialog>
  </div>
</template>

<script>
import Question from '@/components/Question';

export default {
  components: {
    Question,
  },
  data() {
    return {
      dialog: true,
      showLoader: false,
    };
  },
  methods: {
    close() {
      this.$router.push({ name: 'Login' });
    },
  },
  computed: {
    taskAnonymous() {
      return this.$store.getters['completionQuestions/taskAnonymous'];
    },
    taskRef() {
      return this.$route.params.ref;
    },
  },
  mounted() {
    this.showLoader = true;
    const userToken = this.$store.getters['auth/userToken'];
    if (!userToken) {
      this.$store.dispatch('auth/loginAnonymously')
        .then(() => {
          this.$store.dispatch('completionQuestions/getCompletionItems', { task_ref: this.taskRef });
          this.showLoader = false;
        });
    } else {
      this.$store.dispatch('completionQuestions/getCompletionItems', { task_ref: this.taskRef });
      this.showLoader = false;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/DirectCompletionQuestions.vue